module.exports = __webpack_public_path__ + "media/cash-register-cha-ching-9.9a9c5416.mp3";